<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import TariffCoefficientService from "@/domains/lines/services/TariffCoefficientService"
  import TariffCoefficientForm from "@/domains/lines/views/tariffCoefficient/partials/TariffCoefficientForm.vue"

  export default {
    components: {
      Breadcrumbs,
      TariffCoefficientForm,
    },
    data() {
      return {
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Linhas", path: "lines.index" },
          {
            name: "Coeficiente Tarifário",
            path: "lines.tariffCoefficient",
          },
          {
            name: "Novo Reajuste de Coeficiente Tarifário",
            path: "lines.tariffCoefficient/" + this.id,
          },
        ],
        tariffCoefficient: {
          idcoeficientetarifa: null,
          nutransportadora: null,
          dtcadastro: null,
          dtiniciovalidade: null,
          dtfimvalidade: null,
          dtalteracao: null,
          flsituacao: "",
          deter_registry: {
            organization_id: null,
            status_id: null,
            type_id: null,
            field_activity_id: null,
            expire_at: null,
            created_at: null,
            updated_at: null,
            deleted_at: null,
          },
          vlarredondamentotarifa: "",
          vltarifaminimaurbano: "",
          vltarifaminimarodoviario: "",
          valores: [
            // {
            //     idvalorcoeficientetarifa: "",
            //     vltarifa: "",
            //     nutipopreco: "",
            //     nuordemtipopreco: "",
            //     nucoeficientetarifa: "",
            //     tipo: {
            //         idtipopreco: "",
            //         nmtipopreco: "",
            //         tpagrupamento: ""
            //     }
            // },
          ],
        },
        tariffCoefficientService: new TariffCoefficientService(),
      }
    },
    methods: {
      submit() {
        this.tariffCoefficientService
          .createTariffCoefficient(this.tariffCoefficient)
          .then(() => {
            this.$toast.success({
              title: "Sucesso",
              message: "Coeficiente Tarifário criado com sucesso!",
            })
            this.$router.push({ name: "lines.tariffCoefficient" })
          })
          .catch((error) => {
            if (error.length > 1) {
              error.forEach((err) => {
                this.$toast.error({
                  title: "Erro",
                  message: err.message,
                })
              })
              return
            }
            this.$toast.error({
              title: "Erro",
              message: error.message,
            })
          })
      },
    },
  }
</script>
<style>
  .title-type {
    color: white;
    background-image: linear-gradient(to right, #38c172, #029e4d);
  }

  .disabled {
    background-color: #f9f9f9 !important;
  }
</style>

<template>
  <div class="w-full bg-gray-light">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-2" :crumbs="crumbs"/>
      <div
        class="flex flex-wrap justify-between align-baseline border-b-2 border-green-base mb-2"
      >
        <h1 class="text-green-base uppercase pt-5 mb-2">
          Descrição do Coeficiente Tarifário
        </h1>
      </div>
    </div>

    <div class="mb-6">
      <div class="px-2">
        <div class="px-4">
          <div class="px-8 bg-white shadow-md pt-5 pb-5 text-sm">
            <TariffCoefficientForm
              :tariff-coefficient-model="tariffCoefficient"
              @submit="submit"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
